import { Link } from "react-router-dom";
import Button from "../Button/Button";
import oomGameEndImage from "../../assets/images/oomFinal.png";
import GameEndRefreshVector from "../../assets/images/svgComponents/GameEndRefreshVector";
import GameEndReturnVector from "../../assets/images/svgComponents/GameEndReturnVector";
import "./GameEnd.scss";

const GameEnd = ({ childName, gameType, energyLevel }) => {
  const refreshPage = () => {
    window.location.reload();
  };

  let gameTypeLink = "";

  if (gameType == "Swing Game") {
    gameTypeLink = "/swing-game";
  } else if (gameType == "Blending Game") {
    gameTypeLink = "/blending-game";
  } else {
    gameTypeLink = "/swing-game";
  }

  return (
    <div className="game-end">
      <div className="game-end__top">
        <img src={oomGameEndImage} alt="Oom" />
        {energyLevel === 0 ? (
          <>
            <h1 className="game-end__heading game-end__heading--primary">
              Oom has run out of energy
            </h1>
            <p className="game-end__info">
              Oom needs to rest. Take a break and come back tomorrow
            </p>
          </>
        ) : (
          (gameType == "Swing Game" && (
            <>
              <p className="game-end__subheading">Time&apos;s Up</p>
              <h1 className="game-end__heading game-end__heading--secondary">
                Amazing effort {childName}
              </h1>
            </>
          )) ||
          (gameType == "Blending Game" && (
            <>
              <h1 className="game-end__heading game-end__heading--primary">
                Congratulations {childName}!!!
              </h1>
              <p className="game-end__info">
                You managed to correctly guess all of the words and are making
                fantastic progress. Oom&apos;s now feeling much more energised
                thanks to you!
              </p>
            </>
          ))
        )}
        <div className="game-end__buttons">
          <span className="game-end__buttons-wrapper">
            <Button
              label={"Retry"}
              onClick={refreshPage}
              isSecondary
              Icon={GameEndRefreshVector}
            />
          </span>
          <Link to={gameTypeLink}>
            <span className="game-end__buttons-wrapper">
              <Button label={"Back to Games"} Icon={GameEndReturnVector} />
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GameEnd;
